import { render, staticRenderFns } from "./MyReportsTable.vue?vue&type=template&id=119265c8&"
import script from "./MyReportsTable.vue?vue&type=script&lang=js&"
export * from "./MyReportsTable.vue?vue&type=script&lang=js&"
import style0 from "./MyReportsTable.vue?vue&type=style&index=0&id=119265c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports